<template>
    <Card>
      <LocalDataTable :init-document="is_mounted" :functions="functions" :columns="columns" ajax-link="admin/CancelTransactionReason/list"></LocalDataTable>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";
import {mapActions} from "vuex";
import Swal from "sweetalert2";
import {AppApi} from "@/api/AppApi";
import {showSystemNoti} from "@/shared/helper";
let mounted = false;
export default {
  name: "CancelTransactionReasonList",
  components: {LocalDataTable, Card, MasterLayout},
  data(){
    return{
      is_mounted : mounted,
      functions:[
        {name: 'delFunc',method : this.delFunc}
      ],
      columns : [
        {title : 'عنوان'},
        {title : 'نوع کاربر'},
        {title : '<i class="far fa-cogs"></i>',sortable : false,searchable : false},
      ]
    }
  },
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('دلایل کنسل کردن معامله');
    this.setShowHead(true);
    this.is_mounted = mounted;
    mounted = true;
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async delFunc(id,element)
    {
      Swal.fire({
        title: 'آیا مطمئن هستید؟',
        text: "تمام اطلاعات مربوط به دلیل کنسل کردن معامله حذف می شود.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'تایید حذف!',
        cancelButtonText: 'کنسل',
      }).then(async (result) => {
        if (result.value) {
          const result = await AppApi.deleteCancelTransaction(id);
          if (result.ok)
          {
            if (element)
              $(element).closest('tr').remove();
            showSystemNoti('success', result.message);
          }
          else
            showSystemNoti('danger',result.error);
        }
      })
    }
  }
}
</script>

<style scoped>

</style>